/**
 * Calcule la largeur des timelines de manière proportionnelle
 */
export const calculateTimelineWidths = (maxiStep, mandiStep) => {
    const maxWidth = 280;
    const maxSteps = Math.max(maxiStep, mandiStep);

    if (maxSteps === 0) {
        return { upperWidth: maxWidth, lowerWidth: maxWidth, largestWidth: maxWidth };
    }

    const stepWidth = maxWidth / maxSteps;

    return {
        upperWidth: Math.round(stepWidth * maxiStep),
        lowerWidth: Math.round(stepWidth * mandiStep),
        largestWidth: Math.round(stepWidth * maxSteps)
    };
};

/**
 * Calcule la position en pourcentage d'un nombre en tenant compte du thumb du slider
 */
export const calculateNumberPosition = (keyValue, maxSteps, containerWidth) => {
    if (maxSteps === 0) return 0;

    const thumbWidth = 10;
    const ratio = keyValue / maxSteps;
    const thumbCenterPx = (thumbWidth / 2) + ratio * (containerWidth - thumbWidth);
    const percentage = (thumbCenterPx / containerWidth) * 100;

    return percentage;
};

/**
 * Récupère le nombre de steps pour chaque traitement
 * @returns {[number, number]} [maxiStep, mandiStep]
 */
export const getTreatmentPlanningSteps = (treatmentPlanning) => {
    const maxiStep = treatmentPlanning?.tpUpper
        ? Object.keys(treatmentPlanning.tpUpper).length - 2
        : 0;
    const mandiStep = treatmentPlanning?.tpLower
        ? Object.keys(treatmentPlanning.tpLower).length - 2
        : 0;

    return [maxiStep, mandiStep];
};
